import { Component, OnInit } from '@angular/core';
import { StoreService } from '../shared/services/store-service/store.service';
import { environment as env } from '../../../src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  constructor(public storeService: StoreService) {}

  ngOnInit() {}
}
